/**
 * Validates Step 4 "Kiosky" fields.
 * Required: deviceCount (integer >= 1), posProvider, ekasaProvider.
 */
export function validateStep4(values) {
  const errors = {};

  const rawKiosky = values.deviceCount;
  if (rawKiosky === "" || rawKiosky === undefined || rawKiosky === null) {
    errors.deviceCount = "Povinné pole.";
  } else {
    const num = Number(rawKiosky);
    if (Number.isNaN(num)) {
      errors.deviceCount = "Musí byť číslo.";
    } else if (!Number.isInteger(num)) {
      errors.deviceCount = "Musí byť celé číslo.";
    } else if (num < 1) {
      errors.deviceCount = "Minimálne 1.";
    }
  }

  const posProvider = (values.posProvider ?? "").toString().trim();
  if (!posProvider) errors.posProvider = "Povinné pole.";

  const ekasaProvider = (values.ekasaProvider ?? "").toString().trim();
  if (!ekasaProvider) errors.ekasaProvider = "Povinné pole.";

  return errors;
}
